export default __webpack_public_path__ + "static/media/img-0546-denmark-full-face.44ad20e6.png";